import React from "react";
import { routes } from "./route";
import LOGO from "../../assets/logo/logo.png";
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
export default function HeaderDesktop() {
  return (
    <ul className="relative hidden lg:flex lg:items-center gap-5 text-sm h-[140px] py-2 px-20 flex justify-between items-center">
      <div className="flex relative z-20">
        {/* {social.map((data) => {
          const { Icon } = data;
          return (
            <a
              key={data.title}
              href={data.href}
              className="text-white text-xl pr-5"
            >
              <Icon />
            </a>
          );
        })} */}
      </div>
      <div className="absolute w-[100%] h-full left-0 flex justify-center items-center">
        <Link
          to="/"
          onClick={() => {
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            });
          }}
        >
          <img src={LOGO} alt="logo" className="h-[100px]" />
        </Link>
      </div>

      <div className="flex gap-8 relative z-20">
        {routes.map((route) => {
          const { href, title, hash } = route;
          return (
            <li>
              {hash ? (
                <HashLink
                  smooth
                  to={href}
                  className="flex items-center gap-1 hover:text-neutral-400 transition-all text-white text-base font-thin"
                >
                  {title}
                </HashLink>
              ) : (
                <Link
                  key={href}
                  to={href}
                  className="flex items-center gap-1 hover:text-neutral-400 transition-all text-white text-base font-thin"
                >
                  {title}
                </Link>
              )}
            </li>
          );
        })}
      </div>
    </ul>
  );
}
